import { PageView } from '@seeneco-ui/core';
import * as React from 'react';

import LeadsHeader from '@leads/components/header';
import LeadsVirtualList from '@leads/components/virtual-list';
import StandardPaddings from '@ui/standard-paddings';

type LeadsEntryProps = {
	isFetching: boolean;
	leads: Array<Lead>;
	onRequestUpdateLead: (lead: Lead) => void;
	onSendEmailNotification: (lead: Lead) => void;
};

const LeadsEntry: React.FC<LeadsEntryProps> = props => {
	const { isFetching, leads, onRequestUpdateLead, onSendEmailNotification } = props;

	return (
		<PageView.Layout>
			<PageView.Content appearance='paper' fullWidth padding='0'>
				<StandardPaddings>
					<LeadsHeader />
				</StandardPaddings>
				<LeadsVirtualList
					isFetching={isFetching}
					items={leads}
					onRequestUpdateItem={onRequestUpdateLead}
					onSendEmailNotification={onSendEmailNotification}
				/>
			</PageView.Content>
		</PageView.Layout>
	);
};

LeadsEntry.defaultProps = {};
LeadsEntry.displayName = 'LeadsEntry';

export { LeadsEntry, LeadsEntryProps };
